import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { useAuth } from "../auth/AuthContext";
import { api } from "../lib/api";
import { toast } from "sonner";

const OPTIONS = [
  { code: "pt", flag: "🇧🇷", label: "Português" },
  { code: "en", flag: "🇺🇸", label: "English" },
  { code: "es", flag: "🇪🇸", label: "Español" },
];

/**
 * Seletor de idioma PT/EN/ES.
 * - `persist`: além do localStorage, salva no perfil do usuário (PATCH /auth/me).
 * - `compact`: versão mini (PT | EN | ES) para a tela de login.
 */
export function LanguageToggle({ persist = false, compact = false, testId = "language-toggle" }) {
  const { lang, setLang, t } = useI18n();
  const auth = useAuth();

  async function choose(code) {
    if (code === lang) return;
    setLang(code);
    if (persist && auth?.user) {
      try {
        const { data } = await api.patch("/auth/me", { language: code });
        auth.setUser(data);
        const msgs = { en: "Language updated", es: "Idioma actualizado", pt: "Idioma atualizado" };
        toast.success(msgs[code] || msgs.pt);
      } catch {
        // mantém a escolha local mesmo se o PATCH falhar
      }
    }
  }

  return (
    <div
      data-testid={testId}
      role="group"
      aria-label={t("Idioma do sistema")}
      className="inline-flex items-center rounded-full border border-slate-200 bg-slate-100 p-0.5"
    >
      {OPTIONS.map((o) => (
        <button
          key={o.code}
          type="button"
          data-testid={`${testId}-${o.code}`}
          onClick={() => choose(o.code)}
          aria-pressed={lang === o.code}
          className={`inline-flex items-center gap-1.5 rounded-full font-semibold transition-colors ${
            compact ? "px-2.5 py-1 text-[11px]" : "px-3.5 py-1.5 text-xs"
          } ${
            lang === o.code
              ? "bg-white text-slate-900 shadow-sm"
              : "text-slate-500 hover:text-slate-800"
          }`}
        >
          <span aria-hidden="true">{o.flag}</span>
          {compact ? o.code.toUpperCase() : o.label}
        </button>
      ))}
    </div>
  );
}
